export const exchangeBrlABI = [
    {
        payable: false,
        stateMutability: 'nonpayable',
        type: 'constructor',
        inputs: [{ name: 'test', internalType: 'bool', type: 'bool' }],
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'goldBucket', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'stableBucket', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'BucketsUpdated',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'exchanger', internalType: 'address', type: 'address', indexed: true },
            { name: 'sellAmount', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'buyAmount', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'soldGold', internalType: 'bool', type: 'bool', indexed: false },
        ],
        name: 'Exchanged',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'minimumReports', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'MinimumReportsSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'previousOwner', internalType: 'address', type: 'address', indexed: true },
            { name: 'newOwner', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'OwnershipTransferred',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address', indexed: true }],
        name: 'RegistrySet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'reserveFraction', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'ReserveFractionSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'spread', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'SpreadSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'stable', internalType: 'address', type: 'address', indexed: true }],
        name: 'StableTokenSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'updateFrequency', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'UpdateFrequencySet',
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'activateStable',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'buyAmount', internalType: 'uint256', type: 'uint256' },
            { name: 'maxSellAmount', internalType: 'uint256', type: 'uint256' },
            { name: 'buyGold', internalType: 'bool', type: 'bool' },
        ],
        name: 'buy',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'sellAmount', internalType: 'uint256', type: 'uint256' },
            { name: 'minBuyAmount', internalType: 'uint256', type: 'uint256' },
            { name: 'sellGold', internalType: 'bool', type: 'bool' },
        ],
        name: 'exchange',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'sellGold', internalType: 'bool', type: 'bool' }],
        name: 'getBuyAndSellBuckets',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'sellAmount', internalType: 'uint256', type: 'uint256' },
            { name: 'sellGold', internalType: 'bool', type: 'bool' },
        ],
        name: 'getBuyTokenAmount',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'buyAmount', internalType: 'uint256', type: 'uint256' },
            { name: 'sellGold', internalType: 'bool', type: 'bool' },
        ],
        name: 'getSellTokenAmount',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'goldBucket',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'registryAddress', internalType: 'address', type: 'address' },
            { name: 'stableTokenIdentifier', internalType: 'string', type: 'string' },
            { name: '_spread', internalType: 'uint256', type: 'uint256' },
            { name: '_reserveFraction', internalType: 'uint256', type: 'uint256' },
            { name: '_updateFrequency', internalType: 'uint256', type: 'uint256' },
            { name: '_minimumReports', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'initialize',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'initialized',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'isOwner',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'lastBucketUpdate',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'minimumReports',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'owner',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'registry',
        outputs: [{ name: '', internalType: 'contract IRegistry', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'reserveFraction',
        outputs: [{ name: 'value', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'sellAmount', internalType: 'uint256', type: 'uint256' },
            { name: 'minBuyAmount', internalType: 'uint256', type: 'uint256' },
            { name: 'sellGold', internalType: 'bool', type: 'bool' },
        ],
        name: 'sell',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newMininumReports', internalType: 'uint256', type: 'uint256' }],
        name: 'setMinimumReports',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address' }],
        name: 'setRegistry',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newReserveFraction', internalType: 'uint256', type: 'uint256' }],
        name: 'setReserveFraction',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newSpread', internalType: 'uint256', type: 'uint256' }],
        name: 'setSpread',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newStableToken', internalType: 'address', type: 'address' }],
        name: 'setStableToken',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newUpdateFrequency', internalType: 'uint256', type: 'uint256' }],
        name: 'setUpdateFrequency',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'spread',
        outputs: [{ name: 'value', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'stable',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'stableBucket',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'stableTokenRegistryId',
        outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'updateFrequency',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'pure',
        type: 'function',
        inputs: [],
        name: 'getVersionNumber',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
];
